import { useContext } from 'react'
import { Button } from '@mui/material'

import { AccountManualModalContext } from '../step-accounts-connection/association/contexts'
import { ETranslationNs } from 'src/types'
import { HelperWrapper } from '../helper-wrapper'

interface IProps {
  handleAccountsClose: () => void
}

export const AccountManualButton = ({ handleAccountsClose }: IProps) => {
  const { handleOpen: handleModalOpen } = useContext(AccountManualModalContext)

  const handleOpen = () => {
    handleAccountsClose()
    setTimeout(() => {
      handleModalOpen()
    }, 500)
  }

  return (
    <>
      <div>
        <Button onClick={handleOpen}>
          <HelperWrapper t="account-manually-add-button" ns={ETranslationNs.Form} />
        </Button>
      </div>
    </>
  )
}
